import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';

const AdminContext = createContext();

export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showCssEditButton, setShowCssEditButton] = useState(false);
  const [showCssPanel, setShowCssPanel] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  
  const location = useLocation();

  // URL'den admin durumunu kontrol et
  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    // /userId/admin formatını kontrol et
    if (pathParts.length === 2 && pathParts[1] === 'admin') {
      checkExistingLogin();
    } else {
      setShowLoginModal(false);
      setIsAdmin(false);
      setShowCssEditButton(false);
    }
  }, [location]);

  // Mevcut login durumunu kontrol et
  const checkExistingLogin = async () => {
    try {
      // window.rh kontrolü
      if (!window.rh || !window.rh.cr) {
        console.error("hk.js yüklenemedi, window.rh bulunamadı");
        setShowLoginModal(true);
        return;
      }

      // Boş bir body ile check_login isteği gönder
      let body = JSON.stringify({});
      let keys = await window.rh.cr(body);

      const response = await fetch(`${config.adminApi}/check_login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body,
        mode: 'cors',
        credentials: 'include',
      });

      const result = await response.json();

      if (response.ok && (result.status || result.message === "Zaten oturumun açık")) {
        // Kullanıcı zaten login - otomatik login et
        setIsAdmin(true);
        setShowLoginModal(false);
        setShowCssEditButton(true);
      } else {
        // Kullanıcı login değil - login modal göster
        setShowLoginModal(true);
      }
    } catch (error) {
      console.error('Check login API hatası:', error);
      // API hatası durumunda normal login modalını göster
      setShowLoginModal(true);
    }
  };

  const login = useCallback(async (loginData) => {
    setLoginLoading(true);
    setLoginError('');
    
    try {
      // window.rh kontrolü
      if (!window.rh || !window.rh.cr) {
        console.error("hk.js yüklenemedi, window.rh bulunamadı");
        setLoginError('Güvenlik modülü yüklenemedi!');
        setLoginLoading(false);
        return;
      }

      let body = JSON.stringify(loginData);
      let keys = await window.rh.cr(body);

      const response = await fetch(`${config.adminApi}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body,
        mode: 'cors',
        credentials: 'include',
      });

      const result = await response.json();

      if (response.ok && (result.status || result.message === "Zaten oturumun açık")) {
        // Login başarılı (normal login veya zaten oturum açık)
        setIsAdmin(true);
        setShowLoginModal(false);
        setShowCssEditButton(true);
        setLoginError('');
      } else {
        // Login başarısız
        setLoginError(result.message || 'Giriş yapılamadı!');
      }
    } catch (error) {
      console.error('Login API hatası:', error);
      setLoginError('Bağlantı hatası! Lütfen tekrar deneyin.');
    } finally {
      setLoginLoading(false);
    }
  }, []);

  const handleLogin = () => {
    setIsAdmin(true);
    setShowLoginModal(false);
    setShowCssEditButton(true);
  };

  const handleLogout = () => {
    setIsAdmin(false);
    setShowCssEditButton(false);
    setShowCssPanel(false);
  };

  const handleEditCss = () => {
    setShowCssPanel(true);
  };

  const handleCloseCssPanel = () => {
    setShowCssPanel(false);
  };

  return (
    <AdminContext.Provider
      value={{
        isAdmin,
        showLoginModal,
        showCssEditButton,
        showCssPanel,
        loginLoading,
        loginError,
        setShowLoginModal,
        login,
        handleLogin,
        handleLogout,
        handleEditCss,
        handleCloseCssPanel
      }}
    >
      {children}
    </AdminContext.Provider>
  );
}; 